<template>
    <h2 style="margin-top: 2em;">{{message}}</h2>
</template>
<script>
import firebase from '@/firebase/init'
export default { 
    name: 'Approve',
    data(){
        return{
            message: null
        }
    },
    created(){
        var storageRef = firebase.storage().ref()
        var token = this.$route.params.token
        var db = firebase.firestore()
        var thisRef = this
        let ref = db.collection('users').where('ApproveToken', '==', token)
        var user = null
        ref.get().then(snapshot=>{
            if(!snapshot.empty){
                    snapshot.forEach(doc=>{
                        user = doc.data()
                        user.id = doc.id
                        var userRef = db.collection("users").doc(doc.id)
                        userRef.update({
                            Approved: true,
                            ApproveToken: firebase.firebase_.firestore.FieldValue.delete(),
                            DeclineToken: firebase.firebase_.firestore.FieldValue.delete()
                        })
                        .then(function() {
                            //send approved email
                            let avatarRef = storageRef.child(user.Icon)
                            if(avatarRef.location.path !== ""){
                                avatarRef.getDownloadURL().then(function(url) {
                                    user.Icon = url
                                    let sendMail = firebase.functions().httpsCallable('sendApprovedMail')
                                    sendMail({userApproved : user})
                                }).catch(function(error) {
                                    user.Icon = ''
                                    let sendMail = firebase.functions().httpsCallable('sendApprovedMail')
                                    sendMail({userApproved : user})
                                })
                            }
                            //emails about newcomer
                           thisRef.message = "Account is approved"
                        })
                        .catch(function(error) {
                            thisRef.message = "Error approving document"
                            console.error("Error approving document: ", error)
                        })
                    })
            }
            else{
                this.message = "Token doesn't exist"
            }
          })
    },
    beforeCreate: function() {
            document.body.className = 'registration'
            this.$parent.showNavbar = false        
    }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/Approve.vue